"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EppoAssignmentLogger = void 0;
/**
 * Tracks an assignment event by submitting it to the Eppo Ingestion API.
 * Events are queued up for delivery according to the EppoClient's `EventDispatcher` implementation.
 */
class EppoAssignmentLogger {
    constructor(eppoClient) {
        this.eppoClient = eppoClient;
    }
    logAssignment(event) {
        const { entityId: entity_id, experiment, 
        // holdout and holdout_variant come from `extraLogging` in FlagEvaluation
        holdoutKey: holdout, holdoutVariation: holdout_variation, subject, variation, } = event;
        // Skip tracking if no entityId
        if (!entity_id) {
            return;
        }
        const payload = {
            entity_id,
            experiment,
            holdout_variation,
            holdout,
            subject,
            variation,
        };
        this.eppoClient.track('__eppo_assignment', payload);
    }
}
exports.EppoAssignmentLogger = EppoAssignmentLogger;
//# sourceMappingURL=eppo-assignment-logger.js.map